import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const badgeClasses = generateUtilityClasses('AFBadge', [
  'trend',
  'counter',
  'notification',
  'premium',
  'new',
  'beta',
  'coming-soon',
  'custom',
  'recommended',
  'inline'
]);
